<template>
  <div :class="['main-page page-pufa' ]">
    <Menus
      :title="title"
      :home="isPost?true:false"
    >
      <a
        slot="left-link"
        v-if="isPost"
        href="javascript:void(0)"
        @click="getPrev"
      >
      </a>
    </Menus>
    <div class="container-flex content-pufa-list">
      <template v-if="!isPost">
        <div
          class="tab-panel"
          v-if="showTab"
        >
          <div class="tab-list">
            <div
              :class="{'item':true,active:nav.id==active}"
              v-for="nav in category"
              :key="'keys'+nav.id"
              @click="setCategory(nav.id)"
            >
              {{nav.title}}
            </div>
          </div>
        </div>
        <ul :class="{tab:showTab}">
          <li
            v-for="(item,index) in list"
            :key="'key-list-item-'+index"
          >
            <a
              href="javascript:;"
              @click="showPost(item.id)"
            >
              <div class="article">
                <h2 class="title">{{item.title}}</h2>
                <span class="intro">
                  <span>发布时间：{{item.post_time || item.date }}</span>
                  <span class="time">来源：{{item.author || '无'}}</span>
                  <span>{{item.view_count}}次浏览</span>
                </span>
              </div>
              <div
                class="imgs"
                :style="`background-image:url(${item.img[0]})`"
                v-if="item.img.length"
              ></div>
            </a>
          </li>
        </ul>
        <div
          class="foot"
          v-if="isload"
        >
          <div
            class="tip"
            v-if="pagemax"
          >已经全部加载</div>
          <div
            class="more-link"
            v-else
          >
            <a
              href="javascript:void(0)"
              @click="loadMore()"
            >加载更多</a>
          </div>
        </div>
      </template>
      <template v-if="isPost">
        <div class="pufa_detail">
          <div class="title">
            <h1>{{post.title}}</h1>
            <span class="time">发布时间：{{post.post_time || post.date}}</span>
            <span class="time">来源：{{post.author || '无'}}</span>
            <span class="time">浏览量：{{post.view_count}}</span>
          </div>
          <div
            v-if="post.content"
            class="main_text"
            v-html="article_img(post.content)"
          >
          </div>
          <div
            v-if="post.video"
            class="main_text"
          >
            <!-- 增加新媒体标签需要到App.vue中添加音量控制 -->
            <div class="video-div">

              <video
                controls
                controlslist="nodownload"
                id="videopanel6"
                class="video6"
                :poster="post.img[0] || '/img/banner/bg_video.jpg'"
                autoplay="autoplay"
                webkit-playsinline="true"
              >
                <source
                  :src="post.video"
                  type="video/mp4"
                >
              </video>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import Menus from '@/components/Menu'
import { PUFA_INQUIRE, NOTICE } from '../datas/constants/statistics.js'
export default {
  components: {
    Menus
  },
  data () {
    return {
      isPost: false,
      post: '',
      isload: false,
      title: '普法动态',
      page: 1,
      pagemax: 0,
      list: [],
      active: 0,
      category: []
    }
  },
  computed: {
    showTab () {
      return !!this.$route.query.show_tab
    }
  },
  async mounted () {
    const { title, id, } = this.$route.query
    this.title = title || '普法动态'
    if (this.showTab) {
      await this.getCategory()
    }
    await this.getList(this.page)
    let params = ''
    if (id) {
      params = NOTICE[id] ? NOTICE[id] : `ListHasTime_${id}`
    } else {
      params = PUFA_INQUIRE
    }
    if (params) {
      this.$root.getStatistics(params)
    }
  },
  methods: {
    async getCategory () {
      const { result, status } = await this.$get('/pufa/api/post/category/')
      if (!status) return
      this.category = result
      this.active = this.category[0].id
    },
    getPrev () {
      this.isPost = false
      setTimeout(() => {
        $('.container-flex').scrollTop(0, 1000) // eslint-disable-line
      }, 0)
    },
    setCategory (val) {
      this.active = val
      this.page = 1
      this.getList(this.page)
    },
    async getList (page) {
      var webCode = this.$store.state.device.point.code
      const category = this.showTab ? `&category=${this.active}` : ''
      const { result } = await this.$get(this.$route.query.id ? `/pufa/api/post/list/?per_page=10&diagram_id=${this.$route.query.id}&page=${page}` : '/postnews/list/?code=' + webCode + '&page=' + page + category, this)
      this.isload = true
      this.page = page
      if (this.$route.query.id) {
        this.list.push(...result.data.items)
        this.pagemax = result.data.items.length > 9 ? 0 : 1
      } else {
        this.list = page > 1 ? [...this.list, ...result.items] : result.items
        this.pagemax = result.items.length > 4 ? 0 : 1
      }
    },
    async loadMore () {
      if (this.pagemax) return
      this.getList(this.page + 1)
    },
    async showPost (id) {
      const { result } = await this.$get(this.$route.query.id ? `/pufa/post/?post_id=${id}&machine_id=${this.$store.state.device.point.no}&platform=ZD` : '/postnews/view/?post_id=' + id, this)
      this.scrollTop = document.documentElement.scrollTop
      this.post = this.$route.query.title ? result.data : result
      this.isPost = true
      $('.container-flex').scrollTop(0, 1000) // eslint-disable-line
    },
    article_img (html) {
      if (!html.includes('src="http')) {
        // eslint-disable-line
        let dd = html.replace(/src="/g, 'src="https://yn.12348.laway.cn/') // eslint-disable-line
        dd = dd.replace(/background=\"\/image\/xxd.jpg\"/g, '') // eslint-disable-line
        return dd
      } else {
        return html
      }
    }
  },

}
</script>

<style lang="stylus" scoped>
.page-pufa {
  /deep/ {
    .tab-panel {
      height: 0.8rem;
      position: relative;
      background: #fff;
      position: fixed;
      top: 1.2rem;
      display: flex;
      justify-content: center;
      left: 0;
      right: 0;
      border-bottom: 1px solid #eee;
      .tab-list {
        width: 1200px;
        height: 0.8rem;
        left: 50%;
        align-items: center;
        display: flex;
        .item {
          line-height: 0.5rem;
          padding: 0 0.25rem;
          border-radius: 0.12rem;
          &.active {
            background: #f29530;
            color: #fff;
          }
        }
      }
    }
    .video-div {
      width: 10.2rem;
      height: 6rem;
      position: relative;
      border-radius: 0.1rem;
      background-color: rgba(255, 255, 255, 0.08);
      overflow: hidden;
    }
    .video-div .video-bg {
      width: 10.2rem;
      height: 6rem;
      transform: scale(3);
      filter: blur(10px);
      position: absolute;
      z-index: 66;
    }
    .video-div video {
      width: 10.2rem;
      height: 6rem;
      position: absolute;
      z-index: 88;
    }
    .content-pufa-list {
      background: #fff;
      img {
        max-width: 100% !important;
      }
      ul {
        display: block;
        padding: 0;
        &.tab {
          margin-top: 0.8rem;
        }
        li {
          border-bottom: 1px solid #eee;
          a {
            width: 1200px;
            margin: 0 auto;
            display: flex;
            color: #333;
            padding: 0.35rem 0;
          }
          .imgs {
            width: 2.8rem;
            height: 1.5rem;
            background-position: center center;
            background-repeat: no-repeat;
            background-size: cover;
          }
          .article {
            width: 9.2rem;
            display: flex;
            flex-direction: column;
            justify-content: center;
            .title {
              font-size: 0.24rem;
              padding-right: 0.5rem;
              font-weight: normal;
              line-height: 1.6;
            }
            .intro {
              font-size: 0.18rem;
              color: #666;
              line-height: 0.5rem;
              span {
                padding-right: 0.2rem;
              }
            }
          }
        }
      }
      .foot {
        padding: 0.6rem 0;
        font-size: 0.2rem;
        text-align: center;
        .tip {
          color: #666;
        }
        .more-link a {
          display: block;
          width: 2rem;
          height: 0.66rem;
          line-height: 0.66rem;
          margin: 0 auto;
          border: 1px solid #ccc;
          color: #666;
          background: #fff;
        }
      }
      .pufa_detail {
        margin: 0 auto;
        .title {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          background: #eee;
          margin: 0 auto;
          padding: 0.5rem 0;
          .article_type {
            display: block;
            font-size: 0.18rem;
            color: #333;
            margin: 0 auto 0.35rem;
            text-align: center;
          }
          h1 {
            width: 10.5rem;
            font-size: 0.36rem;
            text-align: center;
            color: #333;
            font-weight: normal;
            margin: 0 0 0.2rem;
          }
          .time {
            font-size: 0.14rem;
            color: #aaa;
          }
        }
        .main_text {
          padding: 0.5rem 0 0.6rem;
          width: 10rem;
          margin: 0 auto;
          font-size: 0.2rem;
          line-height: 1.8;
          p {
            color: #7a7a7a;
            margin: 0 0 0.25rem;
            line-height: 1.8 !important;
          }
        }
      }
    }
  }
}
</style>
